/* =============================================================
 * import
 * ========================================================== */
import {gallerySwiper} from "../modules/swiper";

/* =============================================================
 * function
 * ========================================================== */


export default function exe(data) {

  gallerySwiper(data);

}


/* ********************************************
 * function
 * ****************************************** */
